import type {LeadNotesSearch} from "../-types";

import {
  PageSubContainerSkeleton,
  TableSkeleton,
  ToolbarSkeleton,
} from "@project/components/feedback";

import {leadNotesRouteApi} from "../-route-api";

export function LeadNotesPending() {
  const search = leadNotesRouteApi.useSearch() as LeadNotesSearch;
  const perPage = search.perPage ?? 10;

  return (
    <PageSubContainerSkeleton>
      <ToolbarSkeleton>
        <div className="flex w-full gap-3 @lg:w-auto">
          <div className="flex-1 @lg:flex-none">
            <ToolbarSkeleton.Input />
          </div>
        </div>
        <ToolbarSkeleton.Actions className="hidden @lg:flex">
          <ToolbarSkeleton.Button />
        </ToolbarSkeleton.Actions>
      </ToolbarSkeleton>

      <TableSkeleton columns={5} rows={perPage} />
    </PageSubContainerSkeleton>
  );
}
